




import Vue from 'vue';
import OfficialDocumentDetail from '@/components/official-documents/official-document-detail.component.vue';

export default Vue.extend({
  components: {
    'official-document-detail': OfficialDocumentDetail,
  },
});
